import React from 'react';
import '@elastic/eui/dist/eui_theme_light.css';
import { EuiText, EuiFlexGroup, EuiFlexItem, EuiSpacer, EuiPageTemplate, EuiPageHeader, EuiImage } from '@elastic/eui';
import styled from 'styled-components';
import { Header } from '../components/header';
import { Footer } from '../components/footer';
import work1image2 from '../../documents/work1image2.png'
import work1image3 from '../../documents/work1image3.png'

const StyledText = styled.div`
  ul.skills-list {
    display: grid;
    grid-gap: 0 10px;
    padding: 0;
    overflow: hidden;
    list-style: none;

    li {
      position: relative;
      font-family: var(--font-mono);
      font-size: var(--fz-xs);

      &:before {
        content: '• ';
        left: 0;
        color: var(--green);
        font-size: var(--fz-sm);
        line-height: 12px;
      }
    }
  }
`;
class Work1 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            data: [],
            isModalVisible: false,
            files: {},
            uploadDisabled: true,
            selection: [],
            columns: [],
            AlertText: "",
            AlertType: "error",
            entre1Key:['	Project Cost – $ 70K','Capital Management for the entire project','Market Survey for various required services for construction','Working out Architectural plan, Structural plan ','	Preparation of layout of land ','	Working out estimates for overall project','Inventory Management - Material and Machinery ','	Networking with Industry Professionals'], 
            entre1Value:['Entrepreneur approach–Networking','Independent Professional Experience '],  
    }
    }

    render() {

        return (
            <>
                <EuiPageTemplate>
                    <EuiPageHeader><Header /></EuiPageHeader>
                    <EuiSpacer />
                        <EuiText><h2><font face='Segoe UI'>Row House, Satara, India </font></h2></EuiText>
                        <EuiSpacer size='m' />
                        <EuiText><h5><font face='Segoe UI'>March 2021 – Present</font></h5></EuiText>
                        <EuiSpacer size='m' />
                <EuiFlexGroup gutterSize='xl' justifyContent='spaceBetween'>
                <EuiFlexItem>
                        <EuiText>
                        <EuiText><b>Project:</b> G+2 Row House spreading over 5500+ sq. feet</EuiText><EuiSpacer size='m' />
                          <b>Project Highlights</b>
                                  <StyledText><ul className="skills-list">
                                  {this.state.entre1Key && this.state.entre1Key.map((p, i) => <li key={i}>{p}</li>)}
                                  </ul></StyledText>
                                  <b>Value Additions </b>
                                  <StyledText><ul className="skills-list">
                                  {this.state.entre1Value && this.state.entre1Value.map((p, i) => <li key={i}>{p}</li>)}
                                  </ul></StyledText>
                          </EuiText>
                </EuiFlexItem>
                <EuiFlexItem>
                <EuiText textAlign='center'><EuiImage size='l' src={work1image2} /><br/>Survey for Plan Layout</EuiText></EuiFlexItem>
                </EuiFlexGroup>
                <EuiFlexGroup><EuiFlexItem><EuiText textAlign='center'><EuiImage size='xxl' src={work1image3} />
                First Floor Plan</EuiText></EuiFlexItem></EuiFlexGroup>
            <Footer /></EuiPageTemplate>
            </>
        )
    }
};

export { Work1 }